// import Toxic from "../../images/circleIcons/Toxic.png";
// import Battery from "../../images/circleIcons/Battery.png";

const questionAnswers = [
  {
    title: "MARKET FOR DENIM",
    question: "Use the following table to graph the supply curve  for denim.",
    step: 50,
    stepY: 5,
    row: 9,
    col: 6,
    ymax: 45,
    xmax: 300,
    answer: [{x: 50, y: 10}, {x: 150, y: 20}, {x: 250, y: 30}]
  },
  {
    title: "MARKET FOR DENIM",
    // question: "In the process of dying denim with indigo, chemicals are introduced to enable the dye to set, or stick to the cloth, which pollute nearby waterways when untreated in wastewater. Graph the social cost using the table below.",
    question: "Graph the social cost using the table below.",
    step: 50,
    stepY: 5,
    row: 9,
    col: 6,
    ymax: 45,
    xmax: 300,
    answer: [{x: 50, y: 20}, {x: 150, y: 30}, {x: 250, y: 40}]
  },
  {
    title: "MARKET FOR DENIM",
    question: "Now we have added the demand curve, which represents the value of denim to buyers.",
    step: 50,
    stepY: 5,
    row: 9,
    col: 6,
    ymax: 45,
    xmax: 300,
    answer: [{ buy: 20, sell: 20, socialCost: 30, isOptimal: false, }],
  },
  {
    title: "MARKET FOR DENIM",
    question: "",
    step: 50,
    stepY: 5,
    row: 9,
    col: 6,
    ymax: 45,
    xmax: 300,
    answer: [{ buy: 50, sell: 50, socialCost: 150, isOptimal: false, }],
  },
  {
    title: "MARKET FOR DENIM",
    question: "Which of the following is true:",
    step: 50,
    stepY: 5,
    row: 9,
    col: 6,
    ymax: 45,
    xmax: 300,
    options: [
      "The market produces MORE than the socially optimal amount.",
      "The market produces LESS than the socially optimal amount.",
      "The market produces AT the socially optimal amount."
    ],
    answer: 0, //index 1 mean second option
  },
  {
    title: "MARKET FOR DENIM",
    question: "Select the deadweight loss area on the graph.",
    step: 50,
    stepY: 5,
    row: 9,
    col: 6,
    ymax: 45,
    xmax: 300,
    options: [],
    answer: [3], //index 1 mean second option
  },
  {
    title: "MARKET FOR DENIM",
    question: "",
    step: 50,
    stepY: 5,
    row: 9,
    col: 6,
    ymax: 45,
    xmax: 300,
    options: [],
    answer: [], //index 1 mean second option
  },
  // {
  //   title: "MARKET FOR LITHUM",
  //   question: "During the mining process, toxic chemicals leak into the rivers near the mines.",
  //   subQuestion: "Consider the market for oil. What happens?",
  //   icon: Battery,
  //   answer: "Supply curve shifts left",
  //   graphType: "supply curve",
  //   briefness:
  //     "If oil providers think they can charge a higher price for oil in the near future, they will keep oil in the ground. The supply of oil will decrease, the supply curve will shift to the left, and that will result in movement along the existing demand curve.",
  // },
];

export default questionAnswers;
